import '../../logrocketSetup'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import Header from '../Common/Header'
import { redirectToApp, getCookie } from '../../utils'
import { JOB_STATUS, MAIN_APP_URL } from '../../constants'
import { getJobInformation } from '../../api/meeting.api'
import { isValidJobId } from '../../utils/meetingJoinFlow'

const Meeting = () => {
	const { jobId } = useParams()
	const { userType } = useParams()
	const [accessToken, setAccessToken] = useState(null)

	useEffect(() => {
		const accessTokenStatic =
			'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NDc4NDkzMTgsImlhdCI6MTY0NzgzODUxOCwic3ViIjoidXNyX3Q3N1FSTHd1cXgzYmY5UXltIn0.dHv4Ir3O7sacgoYn4C3j_q0LdpGEk2Tq5oZyswggEKI'
		setAccessToken(accessTokenStatic)
	}, [])

	useEffect(() => {
		; (async () => {
			if (!accessToken) {
				return
			}

			if (!isValidJobId(jobId)) {
				return
			}

			const cuId = getCookie('user_id')
			const MAX_RETRIES = 3
			const RETRY_DELAY_MS = 1000
			let jobInfoResponse = { success: false, data: {} }
			let jobInfo = {}

			for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
				jobInfoResponse = await getJobInformation(jobId, cuId)
				if (jobInfoResponse && jobInfoResponse.data && jobInfoResponse.data.id) {
					jobInfo = jobInfoResponse.data
					break
				}
				console.warn(`[InvalidMeeting] getJobInformation attempt ${attempt} failed`)
				if (attempt < MAX_RETRIES) {
					await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS))
				}
			}

			if (jobInfo && jobInfo.id) {
				if (
					jobInfo.status === JOB_STATUS.IN_PROGRESS ||
					jobInfo.status === JOB_STATUS.LONGJOB ||
					jobInfo.status === 'Accepted'
				) {
					window.location.href = `/meeting/${userType}/${jobInfo.id}`
				} else if (jobInfo.status === JOB_STATUS.COMPLETED) {
					localStorage.removeItem('coBrandingLogoUrl')
					window.location.href = `${MAIN_APP_URL}/meeting-feedback/${jobInfo.id}`
				}
			}
		})()
	}, [accessToken])

	return (
		<Row>
			<Col lg="12" style={{ height: '100vh' }}>
				<Row>
					<Col md="4" lg="4" className="m-auto text-center pt-5">
						<Header />
					</Col>

					<Col md="12" lg="12" className="text-center mt-5">
						<h2 className="">
							<span>Invalid meeting ID.</span>
							<span className="mt-4 d-block w-100">
								<Link to="/" onClick={() => redirectToApp('dashboard')}>
									Click here{' '}
								</Link>{' '}
								to open home page.
							</span>
						</h2>
					</Col>
				</Row>
			</Col>
		</Row>
	)
}

export default Meeting
